import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import toast, { Toaster } from "react-hot-toast";

const PaymentViewModal = ({
  show,
  onHide,
  distributorName,
  customerName,
  totalPayable = 0,
  invoiceNum,
  invoiceDate,
}) => {
  const [form, setForm] = useState({
    payingCustomerName: "",
    invoiceNum: "",
    invoiceDate: "",
    paymentMode: "PAID/CASH",
    transactionType: "Purchase",
    amountPaid: "",
  });
useEffect(() => {
  if (show) {
    const today = new Date();

    setForm({
      payingCustomerName:
        distributorName && customerName
          ? `${distributorName} / ${customerName}`
          : distributorName || customerName || "",

      invoiceNum: invoiceNum || `INV-${today.getTime().toString().slice(-6)}`,
      invoiceDate: invoiceDate || today.toISOString(),
      paymentMode: "PAID/CASH",
      transactionType: "Purchase",
      amountPaid: Number(totalPayable).toFixed(2),
    });
  }
}, [show, distributorName, customerName, totalPayable, invoiceNum, invoiceDate]);

  if (!show) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    toast.success("Payment saved!");
    onHide();
  };

  const payable = Number(totalPayable);
  const payingNow = Number(form.amountPaid);
  const balanceDue = payable - payingNow;

  return (
    <>
      <Toaster />

      {/* Overlay */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          zIndex: 999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Modal */}
        <div
          style={{
            background: "#fff",
            width: "90%",
            maxWidth: "500px",
            borderRadius: "12px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
  style={{
    background: "#2c3e50",
    padding: "16px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <div>
    <h2
      style={{
        color: "#fff",
        fontSize: "16px",
        fontWeight: 600,
        margin: 0,
      }}
    >
      Add Payment
    </h2>
    <p
      style={{
        color: "#bdc3c7",
        fontSize: "12px",
        margin: "4px 0 0 0",
      }}
    >
      Fill in the details below to add payment
    </p>
  </div>

  <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
    <button
      onClick={handleSave}
      style={{
        background: "#2c3e50",
        color: "#fff",
        border: "1px solid #fff",
        borderRadius: "6px",
        padding: "8px 16px",
        fontSize: "13px",
        fontWeight: 600,
        cursor: "pointer",
        transition: "all 0.2s",
      }}
    >
      Continue
    </button>

    <button
      onClick={onHide}
      style={{
        background: "transparent",
        border: "none",
        cursor: "pointer",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <X size={20} color="#fff" />
    </button>
  </div>
</div>

          {/* Body */}
          <div style={{ padding: "24px 20px" }}>
            {/* Paying Distributor */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>PAYING PARTY</label>
              <input
                name="payingCustomerName"
                value={form.payingCustomerName}
                readOnly
                style={{ ...inputStyle, background: "#f3f4f6", cursor: "not-allowed" }}
              />
            </div>

            {/* Invoice Number + Date */}
            <div style={twoCol}>
              <div>
                <label style={labelStyle}>INVOICE NUMBER</label>
                <input
                  name="invoiceNum"
                  value={form.invoiceNum}
                  readOnly
                  style={{ ...inputStyle, background: "#f3f4f6", cursor: "not-allowed" }}
                />
              </div>

              <div>
                <label style={labelStyle}>INVOICE DATE</label>
                <input
                  value={new Date(form.invoiceDate).toLocaleDateString("en-GB")}
                  readOnly
                  style={{ ...inputStyle, background: "#f9fafb", cursor: "not-allowed" }}
                />
              </div>
            </div>

            {/* Payment Mode + Transaction Type */}
            <div style={twoCol}>
              <div>
                <label style={labelStyle}>PAYMENT TYPE</label>
                <div style={{ display: "flex", gap: "12px" }}>
                  {["UNPAID/CREDIT", "PAID/CASH"].map((type) => (
                    <label
                      key={type}
                      style={radioStyle(
                        form.paymentMode === type,
                        type === "PAID/CASH" ? "#10b981" : "#0ea5e9",
                        type === "PAID/CASH" ? "#d1fae5" : "#e0f2fe"
                      )}
                    >
                      <input
                        type="radio"
                        name="paymentMode"
                        value={type}
                        checked={form.paymentMode === type}
                        onChange={handleChange}
                      />
                      {type === "PAID/CASH" ? "Cash" : "Credit"}
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label style={labelStyle}>TRANSACTION TYPE</label>
                <select
                  name="transactionType"
                  value={form.transactionType}
                  onChange={handleChange}
                  style={inputStyle}
                >
                  <option value="Purchase">Purchase</option>
                  <option value="Sale">Sale</option>
                  <option value="Customer">Customer</option>
                  <option value="Distributor">Distributor</option>
                </select>
              </div>
            </div>

            {/* Amount Paid */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>AMOUNT PAID *</label>

              <div style={{ position: "relative" }}>
                <span style={rupeeSymbol}>₹</span>
                <input
                  type="number"
                  name="amountPaid"
                  value={form.amountPaid}
                  onChange={handleChange}
                  style={{ ...inputStyle, paddingLeft: "28px" }}
                />
              </div>
            </div>

            {/* Summary Section (Below Save Button) */}
            <div style={summaryBox}>
              <SummaryBox title="PAYABLE AMT" value={`₹${payable}`} />
              <SummaryBox title="PAYING NOW" value={`₹${payingNow}`} />
              <SummaryBox
                title="BALANCE DUE"
                value={balanceDue > 0 ? `₹${balanceDue}` : "—"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

/* Styles */
const labelStyle = {
  fontSize: "11px",
  fontWeight: 700,
  color: "#2c3e50",
  marginBottom: "8px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "2px solid #e5e7eb",
  borderRadius: "6px",
  fontSize: "14px",
};

const twoCol = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "16px",
  marginBottom: "20px",
};

const radioStyle = (active, color, bg) => ({
  padding: "6px 10px",
  borderRadius: "6px",
  border: `2px solid ${active ? color : "#e5e7eb"}`,
  background: active ? bg : "#f9fafb",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  cursor: "pointer",
});

const rupeeSymbol = {
  position: "absolute",
  left: "12px",
  top: "50%",
  transform: "translateY(-50%)",
  fontWeight: 600,
  color: "#6b7280",
};

const summaryBox = {
  background: "#fef3c7",
  padding: "16px",
  borderRadius: "8px",
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "12px",
  marginTop: "20px",
};

const saveBtn = {
  width: "100%",
  padding: "12px",
  background: "#10b981",
  color: "white",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  fontWeight: 600,
  cursor: "pointer",
  marginBottom: "15px",
};

const SummaryBox = ({ title, value }) => (
  <div>
    <div style={{ fontSize: "10px", fontWeight: 700, color: "#92400e", marginBottom: "6px" }}>
      {title}
    </div>
    <div style={{ fontSize: "16px", fontWeight: 700 }}>{value}</div>
  </div>
);

export default PaymentViewModal;
